export default "__VITE_ASSET__B34JHs_I__"